// extracted by mini-css-extract-plugin
export default {"quotesContainer":"Quotes_quotesContainer__rYsR2","quotesNav":"Quotes_quotesNav__nqP+B","quotesRadios":"Quotes_quotesRadios__z9Nz8","generateBtn":"Quotes_generateBtn__xnQoQ"};